import { Modal } from "react-bootstrap";
import "./styles.scss";

const ModalPopup = ({ show, heading, description, buttons, onClose}) => {
  return (
    <Modal show={show} onHide={onClose} centered className="modal" backdropClassName="modal-backdrop" contentClassName="rounded-5"
    >
      <div className="p-4">
        {heading && (
          <div className="d-flex align-items-center mb-3 position-relative pb-2 border-bottom-poup">
            <div className="bold text-start flex-grow-1 header-font-size" >
              {heading}
            </div>

            <button
              type="button"
              className="btn-close ms-2"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
        )}

        <div className="desc-font-size">
          {description}
        </div>
        <div className="d-flex gap-2 btngroup">
          {buttons}
        </div>
      </div>
    </Modal>
  );
};

export default ModalPopup;
